const getEffectSourceType = (effect = {}) => String(
  effect.sourceType
  || effect.provenance?.sourceType
  || effect.data?.provenance?.sourceType
  || '',
).toLowerCase();

const getEffectSourceMode = (effect = {}) => String(
  effect.sourceMode
  || effect.provenance?.mode
  || effect.addedBy
  || effect.data?.sourceMode
  || effect.data?.addedBy
  || effect.data?.provenance?.mode
  || '',
).toLowerCase();

const getEffectAbilityId = (effect = {}) => (
  effect.abilityId
  || effect.sourceAbilityId
  || effect.provenance?.abilityId
  || effect.data?.abilityId
  || effect.data?.sourceAbilityId
  || effect.data?.provenance?.abilityId
  || null
);

const getEffectItemIdentity = (effect = {}) => (
  effect.itemEntryId
  || effect.sourceItemEntryId
  || effect.sourceItemId
  || effect.itemId
  || effect.itemDefinitionId
  || effect.provenance?.itemEntryId
  || effect.provenance?.itemId
  || effect.provenance?.itemDefinitionId
  || effect.provenance?.definitionId
  || effect.data?.itemEntryId
  || effect.data?.sourceItemEntryId
  || effect.data?.sourceItemId
  || effect.data?.itemId
  || effect.data?.itemDefinitionId
  || effect.data?.provenance?.itemEntryId
  || effect.data?.provenance?.itemId
  || effect.data?.provenance?.itemDefinitionId
  || effect.data?.provenance?.definitionId
  || null
);

const ITEM_ABILITY_MODES = new Set(['item-ability', 'server-item-ability']);

export const isEffectInstanceLifecycleAuthorityCandidate = (effect = {}) => (
  !!effect.effectInstanceId
  && getEffectSourceType(effect) === 'item'
  && (
    !!getEffectAbilityId(effect)
    || (
      ITEM_ABILITY_MODES.has(getEffectSourceMode(effect))
      && !!getEffectItemIdentity(effect)
    )
  )
);

export const buildEffectInstanceLifecycleArgs = (effect = {}, actionOverride = null) => {
  if (!isEffectInstanceLifecycleAuthorityCandidate(effect)) return null;
  const action = actionOverride || (effect.isDisabled ? 'enable' : 'disable');
  if (
    action !== 'disable'
    && action !== 'enable'
    && action !== 'archive'
    && action !== 'hide'
    && action !== 'unhide'
  ) return null;
  return {
    effectInstanceId: effect.effectInstanceId,
    action,
    expectedLegacyKey: effect.legacyKey || null,
    expectedStatus: effect.isDisabled ? 'disabled' : 'active',
  };
};
